export const itemsLinks = {
  2023: [
    {
      name: 'Credit Cards',
      url: '/l/awards-credit-cards-2023',
    },
    {
      name: 'Banking',
      url: '/l/awards-banking-2023',
    },
    {
      name: 'Personal Loans',
      url: '/l/awards-personal-loans-2023',
    },
    {
      name: 'Mortgages',
      url: '/l/awards-mortgages-2023',
    },
    {
      name: 'Investing',
      url: '/l/awards-investing-2023',
    },
    {
      name: 'Student Loans',
      url: '/l/awards-student-loans-2023',
    },
    {
      name: 'Insurance',
      url: '/l/awards-insurance-2023',
    },
    {
      name: 'Travel',
      url: '/l/awards-travel-2023',
    },
  ],
  2024: [
    {
      name: 'Credit Cards',
      url: '/l/awards-credit-cards-2024',
    },
    {
      name: 'Personal Loans',
      url: '/l/awards-personal-loans-2024',
    },
    {
      name: 'Banking',
      url: '/l/awards-banking-2024',
    },
    {
      name: 'Investing',
      url: '/l/awards-investing-2024',
    },
    {
      name: 'Mortgages',
      url: '/l/awards-mortgages-2024',
    },
    {
      name: 'Insurance',
      url: '/l/awards-insurance-2024',
    },
    {
      name: 'Travel Rewards',
      url: '/l/awards-travel-rewards-2024',
    },
  ],
  2025: [
    {
      name: 'Credit Cards',
      url: '/l/awards-credit-cards-2025',
    },
    {
      name: 'Banking',
      url: '/l/awards-banking-2025',
    },
    {
      name: 'Insurance',
      url: '/l/awards-insurance-2025',
    },
    {
      name: 'Personal Loans',
      url: '/l/awards-personal-loans-2025',
    },
    {
      name: 'Mortgages',
      url: '/l/awards-mortgages-2025',
    },
    {
      name: 'Investing',
      url: '/l/awards-investing-2025',
    },
    {
      name: 'Travel Rewards',
      url: '/l/awards-travel-rewards-2025',
    },
  ],
  2026: [
    {
      name: 'Credit Cards',
      url: '/l/awards-credit-cards-2026',
    },
    {
      name: 'Banking',
      url: '/l/awards-banking-2026',
    },
    {
      name: 'Insurance',
      url: '/l/awards-insurance-2026',
    },
    {
      name: 'Personal Loans',
      url: '/l/awards-personal-loans-2026',
    },
    {
      name: 'Mortgages',
      url: '/l/awards-mortgages-2026',
    },
    {
      name: 'Investing',
      url: '/l/awards-investing-2026',
    },
    {
      name: 'Travel Rewards',
      url: '/l/awards-travel-rewards-2026',
    },
  ],
  20262: [
    {
      name: 'Credit Cards',
      url: '/l/awards-credit-cards-2026',
    },
    {
      name: 'Banking',
      url: '/l/awards-banking-2026',
    },
    {
      name: 'Insurance',
      url: '/l/awards-insurance-2026',
    },
    {
      name: 'Personal Loans',
      url: '/l/awards-personal-loans-2026',
    },
    {
      name: 'Investing',
      url: '/l/awards-investing-2026',
    },
    {
      name: 'Travel Rewards',
      url: '/l/awards-travel-rewards-2026',
    },
  ],
  20263: [
    // WITH STUDENT LOANS
    {
      name: 'Credit Cards',
      url: '/l/awards-credit-cards-2026',
    },
    {
      name: 'Banking',
      url: '/l/awards-banking-2026',
    },
    {
      name: 'Insurance',
      url: '/l/awards-insurance-2026',
    },
    {
      name: 'Personal Loans',
      url: '/l/awards-personal-loans-2026',
    },
    {
      name: 'Mortgages',
      url: '/l/awards-mortgages-2026',
    },
    {
      name: 'Investing',
      url: '/l/awards-investing-2026',
    },
    {
      name: 'Travel Rewards',
      url: '/l/awards-travel-rewards-2026',
    },
    {
      name: 'Student Loans',
      url: '/l/awards-student-loans-2026',
    },
  ],
};

export const logoLink = {
  name: 'Home',
  url: '/l/awards',
};
